export const ns = "TakePic"

export default {
  [ns]: {
    erase: "Effacer",
    save: "Enregistrer",
    reset: "Réinitialiser",
  },
}
